module.exports = __webpack_public_path__ + "img/qq.82607394.svg";